import { Box } from '@mui/material'
import { ReactNode, useState } from 'react'
import { Lightbox } from 'src/components/lightbox/Lightbox'

type Props = {
  src: string
  alt?: string
  width?: string | number
  aspectRatio?: string
  children?: ReactNode
}

export function ClickableImage({
  src,
  alt = '',
  width = '276px',
  aspectRatio = '1 / 1',
  children,
}: Props) {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false)

  const handleImageClick = () => {
    setIsLightboxOpen(true)
  }

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          width,
          aspectRatio,
          borderRadius: '4px',
          border: '1px solid #d9d9d9',
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.8,
          },
        }}
        onClick={handleImageClick}
      >
        <img
          src={src}
          alt={alt}
          style={{
            objectFit: 'contain',
            position: 'absolute',
            width: '100%',
            height: '100%',
          }}
        />
        {children}
      </Box>
      <Lightbox
        open={isLightboxOpen}
        close={() => setIsLightboxOpen(false)}
        slides={[{ src }]}
        carousel={{ finite: true }}
        controller={{ aria: false, closeOnBackdropClick: true }}
        // ReportLabelでは写真が一枚なので切り替えのボタンは不要
        render={{
          buttonPrev: () => null,
          buttonNext: () => null,
        }}
      />
    </>
  )
}
